<template>
<div class="member_bill_page">
  <div class="page-title">会员流水查询</div>
  <pageTab :paramsLabel="'type'" :isParams="true" :nowTab="nowTab" :tabs="tab"></pageTab>
  <page-search :layout="searchLayout"  @search="search" @exportTable="exportTable"></page-search>
  <pageTable
    :loading="tableLoading"
    :col="col"
    :data="tableData"
    :total="total"
    :pageIndex="page"
    :pageSize="pageSize"
    @compFn="customCompFunc"
    @pageChange="pageChange"
    @pageSizeChange="pageSizeChange"
    ></pageTable>
</div>
</template>
<script>
import pageTab from '@/components/pageCom/pageTab.vue'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import { formatTitle, formatText } from '@/utils/common'
import { downFile } from '@/utils/file'
import { membersLiushui } from '@/api/flow'
import Vue from 'vue'
export default {
  name: 'memberBill',
  components: {
    pageTab, pageSearch, pageTable
  },
  mixins: [pageTableMixin],
  data() {
    return {
      tab: [
        { linkName: 'all', text: '全部' },
        { linkName: 'zhifubao', text: '支付宝' },
        { linkName: 'outline', text: '线下转账' }
      ],
      searchLayout: ['code', 'name', 'date', 'export', 't_agent_info_agent_name'],
      col: [],
      allCol: [ // 全部
        { field: 'order_no', title: '订单编号', width: 240, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'order_time', title: '下单日期', width: 140, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'pay_status', title: '状态', width: 80, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] * 1 === 1) {
              return `<span style="color: #DFA338">审核中</span>`
            } else if (rowData[field] * 1 === 2) {
              return `<span>审核通过</span>`
            } else if (rowData[field] * 1 === 3) {
              return `<span style="color: #DFA338">待付款</span>`
            } else if (rowData[field] * 1 === 4) {
              return `<span>失败订单</span>`
            } else if (rowData[field] * 1 === 5) {
              return `<span>已付款</span>`
            }
          }
        },
        { field: 'pay_type', title: '支付方式', width: 110, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter(rowData) {
            return formatText(rowData.pay_type, ['', '线下转账', '支付宝']) // 1线下转账；2支付宝
          }
        },
        { field: 't_agent_info_agent_name', title: '渠道', width: 160, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cust_name', title: '下单用户', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'order_memo', title: '服务内容', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'order_money', title: '订单金额', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' }
      ],
      zhifubaoCol: [ // 支付宝
        { field: 'order_no', title: '订单编号', width: 230, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData, index, pageIndex, field) {
            return formatTitle(rowData[field])
          }
        },
        { field: 'order_time', title: '下单日期', width: 160, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData, index, pageIndex, field) {
            return formatTitle(rowData[field])
          }
        },
        { field: 'order_status', title: '状态', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData) {
            return formatText(rowData.order_status, ['待付款', '待付款', '已付款'], '', '待付款')
          }
        },
        { field: 'pay_type', title: '支付方式', width: 80, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData) {
            return formatText(rowData.pay_type, ['', '线下转账', '支付宝']) // 1线下转账；2支付宝
          }
        },
        { field: 't_agent_info_agent_name', title: '渠道', width: 160, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cust_name', title: '下单用户', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'order_memo', title: '服务内容', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        // { field: 'buy_amount', title: '数量', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        // { field: '', title: '周期', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'order_money', title: '订单金额', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' }
      ],
      outlineCol: [ // 线下转账
        { field: 'operation', title: '操作', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, componentName: 'operateMemberBill' },
        { field: 'order_no', title: '订单编号', width: 230, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData, index, pageIndex, field) {
            return formatTitle(rowData[field])
          }
        },
        { field: 'order_time', title: '下单日期', width: 160, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData, index, pageIndex, field) {
            return formatTitle(rowData[field])
          }
        },
        { field: 'check_status', title: '状态', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true,
          // formatter(rowData) {
          //   return formatText(rowData.check_status, ['待付款', '待付款', '已付款'], '', '待付款')
          // }
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] * 1 === 0) {
              return `<span style="color: #DFA338">审核中</span>`
            } else if (rowData[field] * 1 === 1) {
              return `<span>审核通过</span>`
            }
          }
        },
        { field: 'pay_type', title: '支付方式', width: 80, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData) {
            return formatText(rowData.pay_type, ['', '线下转账', '支付宝']) // 1线下转账；2支付宝
          }
        },
        { field: 't_agent_info_agent_name', title: '渠道', width: 160, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cust_name', title: '下单用户', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'order_memo', title: '服务内容', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'order_money', title: '订单金额', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' }
      ],
      tmpParams: {} // 搜索成功的临时参数
    }
  },
  computed: {
    nowTab() {
      return this.$route.params.type
    }
  },
  methods: {
    initPage() {
      if (this.$route.params.type === 'all') {
        this.col = this.allCol
      } else if (this.$route.params.type === 'zhifubao') {
        this.col = this.zhifubaoCol
      } else if (this.$route.params.type === 'outline') {
        this.col = this.outlineCol
      }
    },
    search(params) { // 搜索组件传参
      this.page = 1
      this.pageSize = 30
      this.realGetData({
        'per_page': 30,
        page: 1,
        cust_no: params.code,
        cust_name: params.name,
        order_start_time: params.date[0],
        order_end_time: params.date[1],
        t_agent_info_agent_name: params.t_agent_info_agent_name
      })
    },
    exportTable() { // 导出数据
      const downNum = { 'all': '12', 'zhifubao': '8', 'outline': '9' }[this.$route.params.type]
      const query = { ...this.tmpParams, table_type: downNum }
      const url = process.env.VUE_APP_BASE_API + '/business/export_excel'
      downFile(url, query)
    },
    getData(init) { // init代表 mounted watch查询
      if (init) { // 代表的是 mounted watch
        this.realGetData({})
      } else { // 分页获取数据
        this.realGetData(Object.assign({}, this.tmpParams, { 'per_page': this.pageSize, page: this.page }))
      }
    },
    realGetData(params) { // 真正的获取数据 需要参数
      this.tableLoading = true
      if (this.$route.params.type === 'all') {
        membersLiushui('all', params).then(res => {
          this.handleData(res, params)
        })
      } else if (this.$route.params.type === 'zhifubao') {
        membersLiushui('zhifubao', params).then(res => {
          this.handleData(res, params)
        })
      } else if (this.$route.params.type === 'outline') {
        membersLiushui('outline', params).then(res => {
          this.handleData(res, params)
        })
      }
    },
    customCompFunc({ type, data }) {
      this.$router.push({ path: '/trade-detail/check-vip/' + data.check_status + '/' + data.order_no })
    },
    handleData(res, params) { // 统一处理数据
      this.tableLoading = false
      if (res.code === 0) {
        this.tableData = res.result.data
        this.total = res.result.total
        this.tmpParams = params
      } else {
        this.tableData = []
        this.total = 0
      }
    }
  }
}
// 难道是名字一样了吗
Vue.component('operateMemberBill', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    checkVip() {
      this.$emit('on-custom-comp', { type: 'checkVip', data: this.rowData })
    }
  },
  render: function(h) {
    const ope = formatText(this.rowData.check_status, ['审核', '查看'])
    return h('div', {
      class: {
        operate: true
      }
    }, [h('a', {
      on: {
        click: this.checkVip
      }
    }, ope)])
  }
})
</script>
<style lang="scss" scoped>
.member_bill_page {
}
</style>
